<template lang="pug">
  .empty-state.has-text-centered
    .empty-state__icon(v-if="icon")
      b-icon(:icon="icon" size="is-large")
    h3.empty-state__title {{ title }}
    p.empty-state__message(v-if="message") {{ message }}
    .empty-state__body
      slot
    .empty-state__action(v-if="$slots.action")
      slot(name="action")
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: null },
    title: { type: String, required: true },
    message: { type: String, default: null },
  },
};
</script>

<style lang="scss" scoped>
@import "colors";

.empty-state {
  padding: 2.5rem 1.5rem;
  border: 1px dashed $lightGray;
  border-radius: $radius-lg;
  background-color: $sweetGray;

  .empty-state__icon {
    color: $info;
    margin-bottom: 0.5rem;
  }

  .empty-state__title {
    font-size: 1.15rem;
    font-weight: 600;
    color: $darkGray;
  }

  .empty-state__message {
    color: $midGray;
    max-width: 34rem;
    margin: 0.35rem auto 0;
  }

  .empty-state__body {
    color: $midGray;

    &:not(:empty) {
      margin-top: 0.35rem;
    }
  }

  .empty-state__action {
    margin-top: 1.15rem;
  }
}
</style>
